module.exports = __webpack_public_path__ + "assets/img/img87.7403a1b2.png";